import {useState,useEffect,useContext} from "react";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { ErrorAlert } from "../../../alerts/errorAlert";

import {
    FormControl,    
    InputLabel,
    Select,    
    MenuItem     
 } from '@material-ui/core';
 interface SelectInTableProps {
  Array?:any;  
  infoCol?:any;
  type?:string  
  disabledSelect?:boolean
  arrayEval:any
  setArrayEval:any   
  typeArrayEval:any
}

function existsInArray(array: any, id: number): boolean {
  return array.some((item:any) => item.id === id);
}

function getObjectById(array:any, id: number):any {
  return array.find((item:any) => item.id === id);
}
const typesArray = ['lider-ext', 'colegas-ext', 'subornidados-ext', 'clientes-ext']

const SelectInTable = ({infoCol,Array,type,arrayEval,disabledSelect,setArrayEval,typeArrayEval}:SelectInTableProps) => {
  const {state} = useContext(PerformanceEvaluationContext);  
  const [arraySelect, setArraySelect] = useState<any[]>([]);    
  const [value, setValue] = useState('');  
  let { ImagenUsuario, abrvName,areaProject,
        cliente,colega,lider,sede,
        subornidado,__typename,...infoIndCol } = infoCol;      

 useEffect(()=>{          
          if(Array.length >0)
            {        
              const copyArray=[...Array]
              let filteredUsers:any = copyArray.filter((el:any) => {
                 return (parseInt(el.id) !== infoCol.id) 
              });    
              setArraySelect(filteredUsers)       
            } 
  },[Array, infoCol.id])      

  type EvalType = 'lider' | 'colega' | 'subordinado' | 'cliente';

  const verifyValue = (typeArrayEval: EvalType, arraySelect: any, infoIndCol: any) => {
      let newSelect: any;
      let obj: any;
  
      const evalTypes = {
          lider: 'idLider',
          colega: 'idColega',
          subornidado: 'idSubornidado',
          cliente: 'idCliente'
      };
  
      const idType = evalTypes[typeArrayEval as keyof typeof evalTypes];
  
      if (arrayEval.length === 0) {
          if (infoIndCol[idType] !== null) {
              newSelect = arraySelect?.filter((el: any) => el.id === infoIndCol[idType]);
              if (newSelect.length > 0) {
                  const { __typename, ...type } = newSelect[0];
                  obj = {
                      ...infoIndCol,
                      idEval: state._id,
                      [typeArrayEval]: [type]
                  };
                  setValue(obj[typeArrayEval][0].id);
                //  obj.emailSend === 'true' ?setDisabledSelect(true):setDisabledSelect(false)
              }
          }
      } else {
          const verify = existsInArray(arrayEval, infoIndCol.id);
          if (!verify) {
              newSelect = arraySelect?.filter((el: any) => el.id === infoIndCol[idType]);
              if (newSelect.length > 0) {
                  const { __typename, ...type } = newSelect[0];
                  obj = {
                      ...infoIndCol,
                      idEval: state._id,
                      [typeArrayEval]: [type]
                  };
                  setValue(obj[typeArrayEval][0].id);
                 // obj.emailSend === 'true' ?setDisabledSelect(true):setDisabledSelect(false)
                  
              }
          } else {
              const objAct = getObjectById(arrayEval, infoIndCol.id);
              newSelect = arraySelect?.filter((el: any) => el.id === objAct[idType]);
              if (newSelect.length > 0) {
                  const { __typename, ...type } = newSelect[0];
                  obj = {
                      ...objAct,
                      idEval: state._id,
                      [typeArrayEval]: [type]
                  };                  
                  setValue(obj[typeArrayEval][0].id);
                  //obj.emailSend === 'true' ?setDisabledSelect(true):setDisabledSelect(false)
              }
          }
      }  
      return obj;
  };
  
  const updateArrayEval = (res:any, setArrayEval:any) => {
      if (res) {
        setArrayEval((prevArrayEval:any) => {
          const index = prevArrayEval.findIndex((item:any) => item.id === res.id);
          if (index !== -1) {
            return prevArrayEval.map((item:any, i:any) => (i === index ? { ...item, ...res } : item));
          } else {
            return [...prevArrayEval, res];
          }
        });
      } else {
        setValue('');
      }
    };

    useEffect(() => {
      let res:any;
      if (type && ['90', '180', '270', '360'].includes(type)) {
        res = verifyValue(typeArrayEval, arraySelect, infoIndCol);
        updateArrayEval(res, setArrayEval);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [arraySelect, setArrayEval, type, typeArrayEval]);  


    const obj=(type:any,idEval:any,infoIndCol:any,array:any)=>{
      let objRet: any=[]  
      switch (type) {
        case 'lider': case typesArray[0]:          
          objRet ={
            ...infoIndCol,   
                   idLider:array.id,          
                   idEval,              
                   lider: [array]} 
                   setValue(objRet.lider[0].id)    
        return objRet   
        case 'colega':case typesArray[1]:
          objRet ={
            ...infoIndCol,   
                   idColega:array.id,                    
                   idEval,                
                   colega: [array]} 
               setValue(objRet.colega[0].id)           
        return objRet  
        case 'subordinado':case typesArray[2]:
          objRet ={
            ...infoIndCol, 
                   idSubornidado:array.id,                            
                   idEval,                
                   subornidado: [array]}
                   setValue(objRet.subornidado[0].id) 
        return objRet  
        case 'cliente':case typesArray[3]:
          objRet ={        
            ...infoIndCol,   
                   idCliente:array.id,                         
                   idEval,                
                   cliente: [array]} 
                   setValue(objRet.cliente[0].id) 
        return objRet  
   
      }
    }

    const objNew=(type:any,newId:any,newName:any,newEmail:any,newtypeEvaluator:any,array:any,idUser:any)=>{
    let arrayRet: any=[]  
    let updateUser:any=[]
    switch (type) {
    case 'lider': case typesArray[0]:   
       arrayRet=[{
        id:newId,
        name:newName,
        email:newEmail,
        typeEvaluator:newtypeEvaluator
       }]       
       updateUser = arrayEval.map((user: any) => {
          if (user.id === idUser) {
              const updatedUser = {...user,idLider:arrayRet[0].id, lider: arrayRet};
              setValue(updatedUser.lider[0].id);  
              return updatedUser;
          }
          return user;
        });         
    return updateUser   
    case 'colega':case typesArray[1]:
    arrayRet=[{
      id:newId,
      name:newName,
      email:newEmail,
      typeEvaluator:newtypeEvaluator
     }]          
     updateUser = arrayEval.map((user: any) => {
        if (user.id === idUser) {
            const updatedUser = {...user,idColega:arrayRet[0].id ,colega: arrayRet};
            setValue(updatedUser.colega[0].id);  // Suponiendo que newlider siempre tiene al menos un elemento
            return updatedUser;
        }
        return user;
      });         
     return updateUser  
    case 'subordinado':case typesArray[2]:      
      arrayRet=[{
        id:newId,
        name:newName,
        email:newEmail,
        typeEvaluator:newtypeEvaluator
       }]          
       updateUser = arrayEval.map((user: any) => {
          if (user.id === idUser) {
              const updatedUser = {...user,idSubornidado:arrayRet[0].id, subornidado: arrayRet};
              setValue(updatedUser.subornidado[0].id);  // Suponiendo que newlider siempre tiene al menos un elemento
              return updatedUser;
          }
          return user;
        });            
       return updateUser  
    case 'cliente':case typesArray[3]:
        arrayRet=[{
          id:newId,
          name:newName,
          email:newEmail,
          typeEvaluator:newtypeEvaluator
         }]          
         updateUser = arrayEval.map((user: any) => {
            if (user.id === idUser) {
                const updatedUser = {...user,idCliente:arrayRet[0].id, cliente: arrayRet};
                setValue(updatedUser.cliente[0].id);  // Suponiendo que newlider siempre tiene al menos un elemento
                return updatedUser;
            }
            return user;
          }); 
         return updateUser  
      }
    }


   const onChangeEval=(val:any,idUser:any,type:any)=>{
      let newSelect:any=[]  
      let userExist       
      if(val === null){
        return ErrorAlert({ text: 'Es necesario elegir a un evaluador ó agregar a un externo.' });
      }
   switch (type) {
     case '90':
      let obj90
      userExist =arrayEval.find((userId:any)=> userId.id === idUser )
      if(userExist){           
         newSelect= arraySelect?.filter((el:any) => {
         return el.id === val;
        });       
       const { __typename , ...type90}=newSelect[0]          
       const newlider=[{
        id:type90.id,
        name:type90.name,
        email:type90.email,
        typeEvaluator:type90.typeEvaluator
       }]
      const updateUser = arrayEval.map((user: any) => {
        if (user.id === idUser) {
            const updatedUser = {...user,idLider:newlider[0].id, lider: newlider};
            setValue(updatedUser.lider[0].id);  // Suponiendo que newlider siempre tiene al menos un elemento
            return updatedUser;
        }
        return user;
      });       
        setArrayEval(updateUser) 
      }else{     
        newSelect= arraySelect?.filter((el:any) => { return el.id === val; });
        const { __typename , ...type90}=newSelect[0]               
        obj90 ={             
             ...infoIndCol,
             idLider:type90.id,
             idEval: state._id,             
             lider: [type90]
                             }        
         setValue(obj90.lider[0].id)            
         setArrayEval([...arrayEval, obj90])         
      }
    break;
     case '180':
       let obj180
       userExist =arrayEval.find((userId:any)=> userId.id === idUser)
       if(userExist){      
          newSelect= Array?.filter((el:any) => {
          return el.id === val;
         });
        const { __typename , ...type180}=newSelect[0]  
        const res=objNew(newSelect[0].typeEvaluator,type180.id,type180.name,type180.email,type180.typeEvaluator, arrayEval,idUser)                        
        setArrayEval(res)
       }else{
         newSelect= Array?.filter((el:any) => {
         return el.id === val;
       });
       const { __typename , ...type180}=newSelect[0]       
       obj180=obj(newSelect[0].typeEvaluator, state._id , infoIndCol, type180)  
       setArrayEval([...arrayEval, obj180])   
      }   
      break;
     case '270':
       let obj270
       userExist =arrayEval.find((userId:any)=> userId.id === idUser)
       if(userExist){      
          newSelect= Array?.filter((el:any) => {
          return el.id === val;
         });
        const { __typename , ...type270}=newSelect[0]  
        const res=objNew(newSelect[0].typeEvaluator,type270.id,type270.name,type270.email,type270.typeEvaluator, arrayEval,idUser)                
        setArrayEval(res)
      }else{
        newSelect= Array?.filter((el:any) => {
        return el.id === val;
        });
      const { __typename , ...type270}=newSelect[0]       
      obj270=obj(newSelect[0].typeEvaluator, state._id , infoIndCol, type270)   
      setArrayEval([...arrayEval, obj270])   
     }   
      break;
     case '360':
      let obj360
      userExist =arrayEval.find((userId:any)=> userId.id === idUser)     
      if(userExist){      
         newSelect= Array?.filter((el:any) => {
         return el.id === val;
        });
       const { __typename , ...type360}=newSelect[0]  
       const res=objNew(newSelect[0].typeEvaluator,type360.id,type360.name,type360.email,type360.typeEvaluator, arrayEval,idUser)                
       setValue(type360.id)
       setArrayEval(res)
     }else{
       newSelect= Array?.filter((el:any) => {
       return el.id === val;
     });     
     const { __typename , ...type360}=newSelect[0]            
     obj360=obj(newSelect[0].typeEvaluator, state._id , infoIndCol, type360) 
     setValue(type360.id)    
     setArrayEval([...arrayEval, obj360])   
    }  
    break; 
   }
 }


 return (
  <>
     <FormControl
        fullWidth
        size="small"
        variant="outlined">
      <InputLabel id="demo-customized-select-label" style={{ backgroundColor: "#FFFFFF" }}>Seleccionar </InputLabel>
      <Select
        style={{
           textOverflow: "ellipsis",
           whiteSpace: "nowrap",
           overflow: "hidden",
           width: "128px",
           height: "30px"
        }}
        labelId="demo-simple-select-label"
        id="selectArray"
        name="selectArray"
        disabled={disabledSelect}
        value={value ?? ''}
        onChange={
          (e) => {           
            onChangeEval(e.target.value, infoIndCol.id, type);
          }
        }                   
                  >
        {
          arraySelect?.map((option:any) => {           
                return (                  
                  option.id !== null?(
                  <MenuItem key={option.id} value={option.id}>
                  {option.name}
                  </MenuItem>            
                  ):       
                  <MenuItem key={option.id} value={option.id}>
                  {'NA'}
                  </MenuItem>            
                )             
              })                
         
         }
            </Select>               
        </FormControl>   
  </>
  )
}

export default SelectInTable